/**
 * Published versions of an Agent Operating Procedure.
 *
 * These are read-only documents, so the generated CRUD action set does not fit:
 * there is a list keyed by procedure and individual versions keyed by procedure
 * and number, and nothing ever writes one.
 */

import { AOPVersion, AOPVersionSummary } from '../types/AOPTypes';

export const AGENT_PROCEDURE_VERSIONS_ACTION_CONSTANTS = {
	fetchStart: 'AGENT_PROCEDURE_VERSIONS_FETCH_START',
	fetchListSuccess: 'AGENT_PROCEDURE_VERSIONS_FETCH_LIST_SUCCESS',
	fetchOneSuccess: 'AGENT_PROCEDURE_VERSIONS_FETCH_ONE_SUCCESS',
	fetchError: 'AGENT_PROCEDURE_VERSIONS_FETCH_ERROR',
};

export const AGENT_PROCEDURE_VERSIONS_ACTION_CREATORS = {
	fetchStart: () => ({
		type: AGENT_PROCEDURE_VERSIONS_ACTION_CONSTANTS.fetchStart,
	}),
	/**
	 * One page of the history.
	 *
	 * `count` is how many versions there are, not how many came back, so the
	 * picker can say what it is still missing. `append` distinguishes a page
	 * read after the first from a fresh read that replaces what was held.
	 */
	fetchListSuccess: (
		procedureId: string,
		summaries: AOPVersionSummary[],
		count: number,
		append: boolean,
		offset: number
	) => ({
		type: AGENT_PROCEDURE_VERSIONS_ACTION_CONSTANTS.fetchListSuccess,
		procedureId,
		summaries,
		count,
		append,
		offset,
	}),
	fetchOneSuccess: (procedureId: string, version: AOPVersion) => ({
		type: AGENT_PROCEDURE_VERSIONS_ACTION_CONSTANTS.fetchOneSuccess,
		procedureId,
		version,
	}),
	fetchError: (errorMessage: string) => ({
		type: AGENT_PROCEDURE_VERSIONS_ACTION_CONSTANTS.fetchError,
		errorMessage,
	}),
};
